import SettingsIcon from '@mui/icons-material/Settings';
import { styled } from '@mui/material';
import { format } from 'date-fns';
import { useState } from 'react';

import { useGetFiscalYearStart } from '../hooks/useGetFiscalYearStart';
import { FiscalYearModal } from './FiscalYearModal';

export const FiscalYearRange = () => {
  const fiscalYearStart = useGetFiscalYearStart();
  const [modal, setModal] = useState(false);
  return (
    <>
      <Wrapper>
        <Text>Fiscal Year to Date ({format(fiscalYearStart, 'MMMM/yyyy')})</Text>
        <FiscalButton
          onClick={(e) => {
            setModal(true);
            e.stopPropagation();
          }}
        >
          <SettingsIcon fontSize="small" />
        </FiscalButton>
      </Wrapper>
      {modal && <FiscalYearModal onClose={() => setModal(false)} />}
    </>
  );
};

const Wrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Text = styled('span')``;

const FiscalButton = styled('div')`
  color: ${({ theme }) => theme.palette.text.secondary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
